import raiInitWrapper from '@atresmedia/header-bidding';
import { getMeta } from '@atresmedia/datalayer/lib/utils/functions';
import debounce from 'lodash/debounce';
import { node } from 'prop-types';
import React from 'react';
import Axios from 'axios';
import { withAdsContext } from '../../../hocs';
import { adsContextPropType, historyPropType } from '../../../utils';
import adLogger from './logger';

class _AdsController extends React.Component {
  display = debounce(async id => {
    const siteName = getMeta('site-name').toLocaleLowerCase();
    const pageType = getMeta('tipo-pagina').toLocaleLowerCase();
    const adUnit = getMeta('ad-unit');
    const seccion = getMeta('article:section');
    let placements = {};
    const bidders = [];
    const { googletag } = window;

    let host = 'api.atresmedia.com';
    if (window.location.hostname.includes('antena3tv')) {
      host = 'prek8scms.atresmedia.com';
    }

    await Axios.get(
      `https://${host}/cmsproperties/v1/find/${siteName}?key=headerBidding.${pageType}`
    )
      .then(data => {
        placements = data.data;
        if (
          placements !== {} &&
          (!placements.excludes ||
            (placements.excludes &&
              !placements.excludes.some(exclude =>
                window.location.pathname.includes(exclude)
              )))
        ) {
          raiInitWrapper(
            googletag.pubads().getSlots(),
            adUnit,
            seccion,
            placements,
            bidders,
            this.isFirstPage
          );
          adLogger(`Display when is ${this.isFirstPage}`);
          this.isFirstPage = false;
        } else {
          adLogger(`Display del slot ${id}`);
          googletag.display(id);
        }
      })
      .catch(() => {
        placements = {};
        adLogger(`Display del slot ${id}`);
        googletag.display(id);
      });
  }, 200);

  constructor(props) {
    super(props);
    this.pathRef = React.createRef();
    this.pathRef.current = window.location.pathname;
    this.isFirstPage = true;
  }

  componentDidMount() {
    const { googletag } = window;

    if (this.props.history) {
      this.unlisten = this.props.history.listen(event => {
        const { state = {} } = event;

        if (
          this.pathRef.current !== window.location.pathname &&
          !state.isScrollPage &&
          !state.hashNavigation
        ) {
          if (googletag) {
            try {
              adLogger('Destroy slots');
              googletag.destroySlots();
              this.isFirstPage = true;
            } catch (err) {
              console.error(err);
            }
          }
        }
        this.pathRef.current = window.location.pathname;
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { adsContext } = this.props;
    try {
      if (adsContext.state.slots.length) {
        const lastAd = adsContext.state.slots.slice(-1).pop();
        const prevLastAd = prevProps.adsContext.state.slots.slice(-1).pop();
        if (prevLastAd !== lastAd) {
          this.display(lastAd);
        }
      }
    } catch (err) {
      console.error(
        `Google TAG ERROR: Ha ocurrido un error al mostrar los anuncios`
      );
    }
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  render() {
    return this.props.children;
  }
}

_AdsController.propTypes = {
  children: node.isRequired,
  history: historyPropType.isRequired,
  adsContext: adsContextPropType.isRequired
};

const AdsController = withAdsContext(_AdsController);

export default AdsController;
